import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import SearchableSelect from '@/components/common/SearchableSelect';
import { authenticatedBitswanBackendInstance } from '@/lib/api-client';

type ClientRow = { id: string; company_name: string; status_display: string };

export default function ClientSwitcher({ clientId, subPath, current }: {
  clientId: string;
  subPath: string;
  current?: { company_name: string; status_display: string };
}) {
  const navigate = useNavigate();
  const clients = useQuery({
    queryKey: ['advisor-clients'],
    queryFn: async () => {
      const api = await authenticatedBitswanBackendInstance();
      return (await api.get('/advisor/clients/')).data as ClientRow[];
    },
  });

  const rows = clients.data ?? (current ? [{ id: clientId, ...current }] : []);
  const options = rows.map((row) => ({
    value: row.id,
    label: row.company_name,
    keywords: row.status_display,
    hint: row.status_display,
  }));

  return (
    <div className="px-2 py-1">
      <SearchableSelect
        value={clientId}
        onChange={(id) => { if (id && id !== clientId) navigate(`/advisor/clients/${id}/${subPath}`); }}
        options={options}
        placeholder="Pick a client"
        searchPlaceholder="Find a client…"
        emptyText="No client by that name."
        className="h-auto border-0 bg-transparent px-2 py-1.5 font-semibold shadow-none hover:bg-sidebar-accent"
        testId="client-switcher"
      />
      {current && <p className="px-2 text-xs text-muted-foreground">{current.status_display}</p>}
    </div>
  );
}
